import PropTypes from 'prop-types';

const ShopSvg = ({ width, height, palette = [] }) => {
  return (
    <svg
      width={`${width || 80}`}
      height={`${height || 80}`}
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath={`url(#clip0_488_2925${width + height})`}>
        <path
          d="M9.53125 18.75V4.6875H70.4688V18.75H9.53125ZM73.2031 37.5C69.5356 37.5 66.5625 34.5269 66.5625 30.8594C66.5625 34.5269 63.5894 37.5 59.9219 37.5C56.2544 37.5 53.2812 34.5269 53.2812 30.8594C53.2812 34.5269 50.3081 37.5 46.6406 37.5C42.9731 37.5 40 34.5269 40 30.8594C40 34.5269 37.0269 37.5 33.3594 37.5C29.6919 37.5 26.7188 34.5269 26.7188 30.8594C26.7188 34.5269 23.7456 37.5 20.0781 37.5C16.4106 37.5 13.4375 34.5269 13.4375 30.8594C13.4375 34.5269 10.4644 37.5 6.79688 37.5C6.11703 37.5 5.46141 37.3973 4.84375 37.2077V70.625H75.1562V37.2077C74.5387 37.3973 73.883 37.5 73.2031 37.5Z"
          fill={`url(#paint0_linear_488_2925${width + height})`}
        />
        <path
          d="M43.125 14.0625H36.875C35.5806 14.0625 34.5312 13.0131 34.5312 11.7188C34.5312 10.4244 35.5806 9.375 36.875 9.375H43.125C44.4194 9.375 45.4688 10.4244 45.4688 11.7188C45.4688 13.0131 44.4194 14.0625 43.125 14.0625ZM28.2812 11.7188C28.2812 10.4244 27.2319 9.375 25.9375 9.375H19.6875C18.3931 9.375 17.3438 10.4244 17.3438 11.7188C17.3438 13.0131 18.3931 14.0625 19.6875 14.0625H25.9375C27.2319 14.0625 28.2812 13.0131 28.2812 11.7188ZM62.6562 11.7188C62.6562 10.4244 61.6069 9.375 60.3125 9.375H54.0625C52.7681 9.375 51.7188 10.4244 51.7188 11.7188C51.7188 13.0131 52.7681 14.0625 54.0625 14.0625H60.3125C61.6069 14.0625 62.6562 13.0131 62.6562 11.7188ZM75.1562 2.34375C75.1562 1.04937 74.1069 0 72.8125 0H7.1875C5.89313 0 4.84375 1.04937 4.84375 2.34375C4.84375 3.63812 5.89313 4.6875 7.1875 4.6875H72.8125C74.1069 4.6875 75.1562 3.63812 75.1562 2.34375ZM0.15625 25.7812V30.8594C0.15625 34.5269 3.12937 37.5 6.79688 37.5C10.4644 37.5 13.4375 34.5269 13.4375 30.8594C13.4375 34.5269 16.4106 37.5 20.0781 37.5C23.7456 37.5 26.7188 34.5269 26.7188 30.8594C26.7188 34.5269 29.6919 37.5 33.3594 37.5C37.0269 37.5 40 34.5269 40 30.8594C40 34.5269 42.9731 37.5 46.6406 37.5C50.3081 37.5 53.2812 34.5269 53.2812 30.8594C53.2812 34.5269 56.2544 37.5 59.9219 37.5C63.5894 37.5 66.5625 34.5269 66.5625 30.8594C66.5625 34.5269 69.5356 37.5 73.2031 37.5C76.8706 37.5 79.8438 34.5269 79.8438 30.8594V25.7812C79.8438 21.898 76.6958 18.75 72.8125 18.75H7.1875C3.30422 18.75 0.15625 21.898 0.15625 25.7812ZM50.1562 46.4062C50.1562 45.1119 49.1069 44.0625 47.8125 44.0625H32.1875C30.8931 44.0625 29.8438 45.1119 29.8438 46.4062V70.625H50.1562V46.4062ZM25.1562 58.9062V46.4062C25.1562 45.1119 24.1069 44.0625 22.8125 44.0625H11.875C10.5806 44.0625 9.53125 45.1119 9.53125 46.4062V58.9062C9.53125 60.2006 10.5806 61.25 11.875 61.25H22.8125C24.1069 61.25 25.1562 60.2006 25.1562 58.9062ZM70.4688 58.9062V46.4062C70.4688 45.1119 69.4194 44.0625 68.125 44.0625H57.1875C55.8931 44.0625 54.8438 45.1119 54.8438 46.4062V58.9062C54.8438 60.2006 55.8931 61.25 57.1875 61.25H68.125C69.4194 61.25 70.4688 60.2006 70.4688 58.9062ZM79.8438 77.6562V72.9688C79.8438 71.6744 78.7944 70.625 77.5 70.625H2.5C1.20562 70.625 0.15625 71.6744 0.15625 72.9688V77.6562C0.15625 78.9506 1.20562 80 2.5 80H77.5C78.7944 80 79.8438 78.9506 79.8438 77.6562Z"
          fill={`url(#paint1_linear_488_2925${width + height})`}
        />
      </g>
      <defs>
        <linearGradient
          id={`paint0_linear_488_2925${width + height}`}
          x1="40"
          y1="70.625"
          x2="40"
          y2="4.68759"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={palette[2]} />
          <stop offset="1" stopColor={palette[3]} />
        </linearGradient>
        <linearGradient
          id={`paint1_linear_488_2925${width + height}`}
          x1="0.866798"
          y1="79.2781"
          x2="69.6068"
          y2="10.8066"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={palette[0]} />
          <stop offset="1" stopColor={palette[1]} />
        </linearGradient>
        <clipPath id={`clip0_488_2925${width + height}`}>
          <rect width="80" height="80" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

ShopSvg.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  palette: PropTypes.arrayOf(PropTypes.string),
};

export default ShopSvg;
